import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface SystemStatus {
  keys: Record<string, string | string[]>;
  models: { scoring_model: string; chat_model: string };
  config: Record<string, unknown>;
  system: {
    python_version: string;
    app_version: string;
    environment: string;
    uptime_seconds: number;
  };
  database: {
    total_size_mb: number;
    tables: { name: string; rows: number; size_mb: number; index_hit_pct: number }[];
    schema_version: string;
    pool: { size: number; checked_in: number; checked_out: number; overflow: number };
  };
  health: Record<string, { status: string; detail?: string }>;
}

export function useAdminSystem() {
  return useQuery<SystemStatus>({
    queryKey: ["admin", "system"],
    queryFn: () => apiClient.get("api/admin/system").json(),
    retry: false,
  });
}
